import {
  SLAS_REQUEST, SLAS_SUCCESS, SLAS_FAILURE,
  SLA_REQUEST, SLA_SUCCESS, SLA_FAILURE,
  SLA_ADD_REQUEST, SLA_ADD_SUCCESS, SLA_ADD_FAILURE,
  SLA_UPDATE_REQUEST, SLA_UPDATE_SUCCESS, SLA_UPDATE_FAILURE,
  SLA_DELETE_REQUEST, SLA_DELETE_SUCCESS, SLA_DELETE_FAILURE
} from '../actions/slas'

const INITIAL_STATE = {
  slas: null,
  sla: null,
  error: null,
  loading: false,
  slaNeedRefresh: false
}

const slasReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SLAS_REQUEST:
      return { ...state, error: null, loading: true, slaNeedRefresh: false }
    case SLAS_SUCCESS:
      return { ...state, slas: action.response, error: null, loading: false, slaNeedRefresh: false }
    case SLAS_FAILURE:
      return { ...state, error: action.error, loading: false }

    case SLA_REQUEST:
      return { ...state, error: null, loading: true }
    case SLA_SUCCESS:
      return { ...state, sla: action.response, error: null, loading: false }
    case SLA_FAILURE:
      return { ...state, error: action.error, loading: false }

    case SLA_ADD_REQUEST:
      return { ...state, error: null, loading: true }
    case SLA_ADD_SUCCESS:
      return { ...state, slaNeedRefresh: true, sla: action.response, error: null, loading: false }
    case SLA_ADD_FAILURE:
      return { ...state, error: action.error, loading: false }

    case SLA_UPDATE_REQUEST:
      return { ...state, error: null, loading: true }
    case SLA_UPDATE_SUCCESS:
      return { ...state, slaNeedRefresh: true, sla: action.response, error: null, loading: false }
    case SLA_UPDATE_FAILURE:
      return { ...state, error: action.error, loading: false }

    case SLA_DELETE_REQUEST:
      return { ...state, error: null, loading: true }
    case SLA_DELETE_SUCCESS:
      return { ...state, slaNeedRefresh: true, error: null, loading: false }
    case SLA_DELETE_FAILURE:
      return { ...state, error: action.error, loading: false }

    default:
      return state
  }
}

export default slasReducer
